import { render, staticRenderFns } from "./sDevicesNew.vue?vue&type=template&id=37c14454"
import script from "./sDevicesNew.vue?vue&type=script&lang=js"
export * from "./sDevicesNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports